import _defineProperty from "/opt/build/repo/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/build/repo/app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _slicedToArray from "/opt/build/repo/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
var _excluded = ["children", "spacing", "separator", "className", "listProps"],
    _excluded2 = ["spacing"],
    _excluded3 = ["isCurrentPage", "as", "className", "href"],
    _excluded4 = ["isCurrentPage", "separator", "isLastChild", "spacing", "children", "className"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// ../../../react-shim.js
import React from "react"; // ../../utilities/shared-utils/src/index.ts

var cx = function cx() {
  for (var _len = arguments.length, classNames = new Array(_len), _key = 0; _key < _len; _key++) {
    classNames[_key] = arguments[_key];
  }

  return classNames.filter(Boolean).join(" ");
}; // src/breadcrumb.tsx


import { getValidChildren } from "@chakra-ui/react-children-utils";
import { chakra, forwardRef, omitThemingProps, useMultiStyleConfig } from "@chakra-ui/system";
import { cloneElement } from "react"; // src/breadcrumb-context.ts

import { createContext } from "@chakra-ui/react-context";

var _createContext = createContext({
  name: "BreadcrumbStylesContext",
  errorMessage: "useBreadcrumbStyles returned is 'undefined'. Seems you forgot to wrap the components in \"<Breadcrumb />\" "
}),
    _createContext2 = _slicedToArray(_createContext, 2),
    BreadcrumbStylesProvider = _createContext2[0],
    useBreadcrumbStyles = _createContext2[1]; // src/breadcrumb.tsx


var Breadcrumb = forwardRef(function Breadcrumb2(props, ref) {
  var styles = useMultiStyleConfig("Breadcrumb", props);
  var ownProps = omitThemingProps(props);

  var children = ownProps.children,
      _ownProps$spacing = ownProps.spacing,
      spacing = _ownProps$spacing === void 0 ? "0.5rem" : _ownProps$spacing,
      _ownProps$separator = ownProps.separator,
      separator = _ownProps$separator === void 0 ? "/" : _ownProps$separator,
      className = ownProps.className,
      listProps = ownProps.listProps,
      rest = _objectWithoutProperties(ownProps, _excluded);

  var validChildren = getValidChildren(children);
  var count = validChildren.length;
  var clones = validChildren.map(function (child, index) {
    return cloneElement(child, {
      separator: separator,
      spacing: spacing,
      isLastChild: count === index + 1
    });
  });

  var _className = cx("chakra-breadcrumb", className);

  return /* @__PURE__ */React.createElement(chakra.nav, _objectSpread({
    ref: ref,
    "aria-label": "breadcrumb",
    className: _className,
    __css: styles.container
  }, rest), /* @__PURE__ */React.createElement(BreadcrumbStylesProvider, {
    value: styles
  }, /* @__PURE__ */React.createElement(chakra.ol, _objectSpread(_objectSpread({
    className: "chakra-breadcrumb__list"
  }, listProps), {}, {
    __css: _objectSpread({
      display: "flex",
      alignItems: "center"
    }, styles.list)
  }), clones)));
});
Breadcrumb.displayName = "Breadcrumb"; // src/breadcrumb-item.tsx

import { chakra as chakra4, forwardRef as forwardRef4 } from "@chakra-ui/system";
import { getValidChildren as getValidChildren2 } from "@chakra-ui/react-children-utils"; // src/breadcrumb-separator.tsx

import { chakra as chakra2, forwardRef as forwardRef2 } from "@chakra-ui/system";
var BreadcrumbSeparator = forwardRef2(function BreadcrumbSeparator2(props, ref) {
  var spacing = props.spacing,
      rest = _objectWithoutProperties(props, _excluded2);

  var styles = useBreadcrumbStyles();

  var separatorStyles = _objectSpread({
    mx: spacing
  }, styles.separator);

  return /* @__PURE__ */React.createElement(chakra2.span, _objectSpread(_objectSpread({
    ref: ref,
    role: "presentation"
  }, rest), {}, {
    __css: separatorStyles
  }));
});
BreadcrumbSeparator.displayName = "BreadcrumbSeparator"; // src/breadcrumb-link.tsx

import { chakra as chakra3, forwardRef as forwardRef3 } from "@chakra-ui/system";
var BreadcrumbLink = forwardRef3(function BreadcrumbLink2(props, ref) {
  var isCurrentPage = props.isCurrentPage,
      as = props.as,
      className = props.className,
      href = props.href,
      rest = _objectWithoutProperties(props, _excluded3);

  var styles = useBreadcrumbStyles();

  var sharedProps = _objectSpread({
    ref: ref,
    as: as,
    className: cx("chakra-breadcrumb__link", className)
  }, rest);

  if (isCurrentPage) {
    return /* @__PURE__ */React.createElement(chakra3.span, _objectSpread({
      "aria-current": "page",
      __css: styles.link
    }, sharedProps));
  }

  return /* @__PURE__ */React.createElement(chakra3.a, _objectSpread({
    __css: styles.link,
    href: href
  }, sharedProps));
});
BreadcrumbLink.displayName = "BreadcrumbLink"; // src/breadcrumb-item.tsx

import { cloneElement as cloneElement2 } from "react";
var BreadcrumbItem = forwardRef4(function BreadcrumbItem2(props, ref) {
  var isCurrentPage = props.isCurrentPage,
      separator = props.separator,
      isLastChild = props.isLastChild,
      spacing = props.spacing,
      children = props.children,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded4);

  var validChildren = getValidChildren2(children);
  var clones = validChildren.map(function (child) {
    if (child.type === BreadcrumbLink) {
      return cloneElement2(child, {
        isCurrentPage: isCurrentPage
      });
    }

    if (child.type === BreadcrumbSeparator) {
      return cloneElement2(child, {
        spacing: spacing,
        children: child.props.children || separator
      });
    }

    return child;
  });
  var styles = useBreadcrumbStyles();

  var itemStyles = _objectSpread({
    display: "inline-flex",
    alignItems: "center"
  }, styles.item);

  var _className = cx("chakra-breadcrumb__list-item", className);

  return /* @__PURE__ */React.createElement(chakra4.li, _objectSpread(_objectSpread({
    ref: ref,
    className: _className
  }, rest), {}, {
    __css: itemStyles
  }), clones, !isLastChild && /* @__PURE__ */React.createElement(BreadcrumbSeparator, {
    spacing: spacing
  }, separator));
});
BreadcrumbItem.displayName = "BreadcrumbItem";
export { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbSeparator, useBreadcrumbStyles };